import {
  PageType,
  buildPageParametersByUrl,
  formatTealiumTrackingObject,
} from '@congstar/tealium-tracking';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * Hook to ensure that tealium pushes are executed
 * @returns setTrackingObject
 */
export function useTealiumTracking(): {
  setTrackingObject: Dispatch<
    SetStateAction<Record<string, string> | undefined | null>
  >;
} {
  const [trackingObjects, setTrackingObject] = useState<
    Record<string, string> | undefined | null
  >();

  useEffect(() => {
    if (window?.utag?.view) {
      pushPageView();
    }
  }, [window?.utag?.view]);

  // push pending tealium objects on utag load
  useEffect(() => {
    if (window?.utag?.link && trackingObjects) {
      window.utag.link(trackingObjects);
      setTrackingObject(null);
    }
  }, [window?.utag?.link, trackingObjects]);

  return { setTrackingObject };
}

/**
 * Function to build tracking object
 * @param linkId
 * @param eventDetail
 * @returns tealium tracking object
 */
export function createTrackingObject(
  linkId: string,
  eventDetail: string | undefined,
): Record<string, string> {
  return {
    ...formatTealiumTrackingObject({
      ...createPageObject(),
      event_detail_1: eventDetail,
    }),
    /**
     * Unfortunately it is necessary to exclude tealium_event and link_id from
     * formatTealiumTrackingObject as they contain special characters that would be
     * incorrectly replaced by the function
     */
    tealium_event: 'passwortreset.event',
    link_id: linkId,
  };
}

function createPageObject() {
  return {
    ...buildPageParametersByUrl(
      new URL(window.location.href),
      PageType.HILFE_UND_SERVICE,
    ),
  };
}

function pushPageView() {
  window?.utag?.view(formatTealiumTrackingObject(createPageObject()));
}
